export const DIALOG_Z_INDEX = 1300;
export const LOADING_Z_INDEX = DIALOG_Z_INDEX + 1;
export const USER_ROLES_BOTTOM_BAR_Z_INDEX = DIALOG_Z_INDEX - 1;
export const EDITOR_Z_INDEX = USER_ROLES_BOTTOM_BAR_Z_INDEX - 1;
export const USERS_AND_ROLES_Z_INDEX = EDITOR_Z_INDEX - 1;
export const ACCOUNT_MODAL_Z_INDEX = USERS_AND_ROLES_Z_INDEX;
export const BOTTOM_BAR_Z_INDEX = USERS_AND_ROLES_Z_INDEX - 1;
export const LEFT_NAVIGATION_BAR_WIDTH = 170;
